import PropTypes from 'prop-types'
import React from 'react'
import { Label, Input, OuterCircle, InnerCircle, Text, IconsWrapper } from './styles.js'
import Icon from 'components/Icon'

const RadioButtonInner = ({
  input: { checked, ...inputOptions },
  label,
  isDisabled,
  icons,
  iconHeight,
  ...props
}) => (
    
  <Label isChecked={checked} isDisabled={isDisabled}>
    <Input
      {...inputOptions}
      {...props}
      type="radio"
      disabled={isDisabled}
    />
    <OuterCircle isChecked={checked}>
      <InnerCircle />
    </OuterCircle>
    <Text>{label}</Text>

    {icons && (
      <IconsWrapper isMultiIcon={icons.length>2} isDoubleIcon={icons.length===2}>
        {icons.map((icon) => (
          <div
            style={{
              height: iconHeight,
              width: icon.width,
              flex: '0 0 auto',
              display: 'flex',
              alignItems: 'center',
            }}
            key={icon.id}
          >
            <Icon id={icon.id} />
          </div>
        ))}
      </IconsWrapper>
    )}
  </Label>
)

RadioButtonInner.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  icons: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          width: PropTypes.string,
        })
      ),
  iconHeight: PropTypes.string
}

export default RadioButtonInner
